import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { generateRedirectUrl } from '../../../packages/common/utils/getRedirectUrl';

const RedirectToRedmine = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/projects');
  }, [navigate]);
  return null;
};

export default RedirectToRedmine;
